import React from "react";

const ShareModal = ({link, personName, memorialMessage, onClose}) => {
    const tributeName = (personName || "").trim() || "bliskiej osoby";
    const tributeMessage = (memorialMessage || "").trim();
    const messageSuffix = tributeMessage ? ` "${tributeMessage}"` : "";
    const shareMessage = `Właśnie udało mi się zapalić wirtualnego znicza dla ${tributeName}${messageSuffix}

Zobacz i też postaw swój znicz`;
    const whatsappMessage = `${shareMessage}\n\n${link}`;

    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}&quote=${encodeURIComponent(shareMessage)}`;
    const whatsappWebUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(whatsappMessage)}`;

    const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent || "";
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    const isAndroid = /Android/i.test(userAgent);
    const isMobile = isIOS || isAndroid;
    const canUseNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

    const loadHtml2Canvas = () => {
        if (window.html2canvas) {
            return Promise.resolve(window.html2canvas);
        }

        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
            script.onload = () => resolve(window.html2canvas);
            script.onerror = () => reject(new Error("Failed to load html2canvas"));
            document.head.appendChild(script);
        });
    };

    const launchDeepLink = (deepLink, fallbackUrl, fallbackDelay = 800) => {
        if (typeof window === "undefined") {
            return;
        }

        let fallbackTimer;

        const cleanup = () => {
            if (fallbackTimer) {
                clearTimeout(fallbackTimer);
            }

            if (typeof document !== "undefined") {
                document.removeEventListener("visibilitychange", handleVisibilityChange);
            }

            window.removeEventListener("pagehide", cleanup);
        };

        const handleVisibilityChange = () => {
            if (typeof document === "undefined") {
                return;
            }

            if (document.visibilityState === "hidden") {
                cleanup();
            }
        };

        if (typeof document !== "undefined") {
            document.addEventListener("visibilitychange", handleVisibilityChange);
        }

        window.addEventListener("pagehide", cleanup);

        fallbackTimer = setTimeout(() => {
            window.open(fallbackUrl, "_blank", "noopener");
            cleanup();
        }, fallbackDelay);

        window.location.href = deepLink;

        setTimeout(cleanup, fallbackDelay + 2000);
    };

    const openFacebookApp = () => {
        if (typeof window === "undefined") {
            return;
        }

        if (!isMobile) {
            window.open(facebookShareUrl, "_blank", "noopener");
            return;
        }

        const facebookDeepLink = `fb://facewebmodal/f?href=${encodeURIComponent(facebookShareUrl)}`;
        const fallbackDelay = isIOS ? 1600 : 800;

        launchDeepLink(facebookDeepLink, facebookShareUrl, fallbackDelay);
    };

    const openWhatsApp = () => {
        if (typeof window === "undefined") {
            return;
        }

        if (isMobile) {
            const whatsappDeepLink = `whatsapp://send?text=${encodeURIComponent(whatsappMessage)}`;
            launchDeepLink(whatsappDeepLink, whatsappWebUrl, 800);
            return;
        }

        window.open(whatsappWebUrl, "_blank", "noopener");
    };

    const handleFacebookShare = (event) => {
        event.preventDefault();
        openFacebookApp();
    };

    const handleWhatsAppShare = (event) => {
        event.preventDefault();
        openWhatsApp();
    };

    const handleNativeShare = (event) => {
        event.preventDefault();

        if (canUseNativeShare) {
            navigator
                .share({
                    title: "japamietam.pl",
                    text: shareMessage,
                    url: link,
                })
                .catch(() => {
                });
        } else {
            alert("Udostępnianie systemowe nie jest wspierane na tym urządzeniu.");
        }
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(link);
        alert("Link skopiowano do schowka!");
    };

    const handleDownloadTribute = async () => {
        const element = document.querySelector('.tribute-preview-container');
        if (!element) {
            alert('Nie znaleziono podglądu znicza.');
            return;
        }

        try {
            const html2canvasLib = await loadHtml2Canvas();
            const canvas = await html2canvasLib(element, { scale: 2, useCORS: true });
            const image = canvas.toDataURL('image/png');
            const downloadLink = document.createElement('a');
            downloadLink.href = image;
            downloadLink.download = 'znicz.png';
            downloadLink.click();
        } catch (error) {
            console.error('Failed to download tribute image:', error);
            alert('Nie udało się pobrać znicza.');
        }
    };

    const socialButtons = [
        {
            name: "Facebook",
            onClick: handleFacebookShare,
            url: facebookShareUrl,
        },
        {
            name: "WhatsApp",
            onClick: handleWhatsAppShare,
            url: whatsappWebUrl,
        },
        ...(canUseNativeShare
            ? [
                {
                    name: "Udostępnij na telefonie",
                    onClick: handleNativeShare,
                },
            ]
            : []),
        {
            name: "Twitter",
            url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}`,
        },
    ];

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Udostępnij znicz</h2>
                <div className="social-share-buttons">
                    {socialButtons.map((button) =>
                        button.url ? (
                            <a
                                href={button.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-share-button"
                                key={button.name}
                                onClick={button.onClick}
                            >
                                {button.name}
                            </a>
                        ) : (
                            <button
                                type="button"
                                className="social-share-button"
                                key={button.name}
                                onClick={button.onClick}
                            >
                                {button.name}
                            </button>
                        )
                    )}
                </div>
                <div className="generated-link-container">
                    <p>Twój link do udostępnienia:</p>
                    <input type="text" value={link} readOnly/>
                    <button type="button" onClick={handleCopyLink}>
                        Kopiuj
                    </button>
                </div>
                <button type="button" className="download-button" onClick={handleDownloadTribute}>
                    Pobierz znicz
                </button>
                <button className="close-button" onClick={onClose}>
                    Zamknij
                </button>
            </div>
        </div>
    );
};

export default ShareModal;
